import React, { ReactNode, useRef } from "react";
import { DropTargetMonitor, useDrag, useDrop } from "react-dnd";

export interface ListItemProps {
  moveItem: (draggedId: string | number, index: number) => void;
  children: ReactNode;
  index: number;
  type: string;
  isDisabled: boolean;
}

const ContentListItemWrapper = ({
  children,
  moveItem,
  index,
  type,
  isDisabled,
}: ListItemProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const [, connectDrag] = useDrag({
    type,
    item: { index },
    canDrag: Boolean(moveItem),
  });

  const [, connectDrop] = useDrop({
    accept: type,
    hover(item: { index: number }, monitor: DropTargetMonitor) {
      const dropItem = item;
      const draggedIndex = dropItem.index;
      const targetIndex = index;

      if (draggedIndex === targetIndex) {
        return;
      }

      const targetSize = ref.current?.getBoundingClientRect();
      const targetCenter =
        ((targetSize?.bottom || 0) - (targetSize?.top || 0)) / 2;
      const draggedOffset = monitor.getClientOffset();
      const draggedTop = (draggedOffset?.y || 0) - (targetSize?.top || 0);

      if (draggedIndex < targetIndex && draggedTop < targetCenter) {
        return;
      }

      if (draggedIndex > targetIndex && draggedTop > targetCenter) {
        return;
      }

      moveItem(draggedIndex, targetIndex);
      dropItem.index = targetIndex;
    },
  });

  connectDrag(ref);
  connectDrop(ref);

  return (
    <div
      className="tab-list-item"
      ref={ref}
      style={{
        opacity: isDisabled ? "0.5" : "1",
      }}
    >
      {children}
    </div>
  );
};

export default ContentListItemWrapper;
